import React, { useState, useEffect } from "react";

const formatPrice = (value) => `${Number(value || 0).toFixed(2)} €`;

const CartItemEditModal = ({ isOpen, item, costMap, onClose, onValidate }) => {
  const [quantity, setQuantity] = useState(1);
  const [price, setPrice] = useState(0);
  const [isEditingPrice, setIsEditingPrice] = useState(false);
  const [discountType, setDiscountType] = useState("€"); // € or %
  const [discountApplyType, setDiscountApplyType] = useState("all"); // 'one' or 'all'
  const [discountValue, setDiscountValue] = useState("");
  const [note, setNote] = useState("");

  useEffect(() => {
    if (isOpen && item) {
      setQuantity(item.quantity || 1);
      setPrice(item.price || 0);
      setNote(item.note || "");
      if (item.lineDiscountType) {
        setDiscountType(item.lineDiscountType);
        setDiscountValue(item.lineDiscountValue || "");
        setDiscountApplyType(item.lineDiscountApplyType || "all");
      } else {
        setDiscountType("€");
        setDiscountValue("");
        setDiscountApplyType("all");
      }
      setIsEditingPrice(false);
    }
  }, [isOpen, item]);

  if (!isOpen || !item) return null;

  const product = item.product || {};
  const entry = product.id ? costMap.get(product.id) : null;
  const purchasePrice = entry ? entry.unitCost : (product.purchasePrice || 0);
  const stock = product.stock || 0;
  const ref = product.barcode || product.sku || "N/A";

  const handleValidate = () => {
    onValidate({
      quantity: quantity,
      price: parseFloat(price) || 0,
      note: note,
      lineDiscountType: discountType,
      lineDiscountValue: parseFloat(discountValue) || 0,
      lineDiscountApplyType: discountApplyType
    });
  };

  return (
    <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1055 }}>
      <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "400px" }}>
        <div className="modal-content border-0 shadow-lg" style={{ borderRadius: "12px", backgroundColor: "#f2f2f2" }}>
          
          {/* Header */}
          <div className="d-flex p-3 border-bottom pb-2">
            <div className="bg-white p-1 rounded shadow-sm me-3" style={{ width: "60px", height: "60px", flexShrink: 0 }}>
              <img 
                src={product.imageUrl || "/placeholder.png"} 
                alt={item.title} 
                style={{ width: "100%", height: "100%", objectFit: "contain" }}
                onError={(e) => { e.target.src = "https://via.placeholder.com/60"; }}
              />
            </div>
            <div className="flex-grow-1">
              <h5 className="mb-2 text-dark" style={{ fontSize: "1.1rem" }}>{item.title}</h5>
            </div>
          </div>

          <div className="modal-body p-3 pt-2">
            {/* Info and Price */}
            <div className="d-flex justify-content-between align-items-start mb-3">
              <div className="text-muted" style={{ fontSize: "0.85rem" }}>
                <div className="fw-bold text-dark">Réf. {ref}</div>
                <div>Stock : {stock}</div>
                <div>Prix d'achat : {formatPrice(purchasePrice)}</div>
              </div>
              <div className="d-flex align-items-center">
                <button 
                  className="btn btn-sm text-white me-2" 
                  style={{ backgroundColor: "#85d6ed", borderRadius: "4px" }}
                  onClick={() => setIsEditingPrice(!isEditingPrice)}
                >
                  <i className="bi bi-pencil-fill"></i>
                </button>
                {isEditingPrice ? (
                  <input 
                    type="number" 
                    className="form-control text-danger fw-bold fs-5 p-1" 
                    style={{ width: "80px" }} 
                    value={price} 
                    onChange={(e) => setPrice(e.target.value)} 
                    autoFocus
                  />
                ) : (
                  <span className="text-danger fw-bold fs-4">{formatPrice(price)}</span>
                )}
              </div>
            </div>

            {/* Quantity Controls */}
            <div className="d-flex mb-4">
              <button 
                className="btn btn-light border fw-bold text-danger fs-5" 
                style={{ flex: 1, borderTopLeftRadius: "8px", borderBottomLeftRadius: "8px" }}
                onClick={() => setQuantity(Math.max(1, quantity - 1))}
              >
                −
              </button>
              <div className="bg-light border-top border-bottom d-flex align-items-center justify-content-center fw-bold fs-5" style={{ flex: 2 }}>
                {quantity}
              </div>
              <button 
                className="btn btn-light border fw-bold text-warning fs-5" 
                style={{ flex: 1, borderTopRightRadius: "8px", borderBottomRightRadius: "8px" }}
                onClick={() => setQuantity(quantity + 1)}
              >
                +
              </button>
            </div>

            {/* REMISE */}
            <div className="mb-4">
              <div className="text-uppercase text-secondary mb-2" style={{ letterSpacing: "1px", fontSize: "0.9rem" }}>REMISE</div>
              <div className="d-flex align-items-center mb-2">
                <div className="d-flex flex-column me-2" style={{ fontSize: "0.8rem", color: "#6c757d" }}>
                  <label className="d-flex align-items-center mb-1 cursor-pointer">
                    <input 
                      type="radio" 
                      name="discountApplyType" 
                      className="me-1" 
                      checked={discountApplyType === "one"}
                      onChange={() => setDiscountApplyType("one")}
                    /> 
                    X 1
                  </label>
                  <label className="d-flex align-items-center cursor-pointer">
                    <input 
                      type="radio" 
                      name="discountApplyType" 
                      className="me-1" 
                      checked={discountApplyType === "all"}
                      onChange={() => setDiscountApplyType("all")}
                    /> 
                    X N
                  </label>
                </div>
                <div className="flex-grow-1 d-flex">
                  <input 
                    type="number" 
                    className="form-control" 
                    placeholder="Valeur de la remise" 
                    value={discountValue}
                    onChange={(e) => setDiscountValue(e.target.value)}
                    style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                  />
                  <button 
                    className={`btn fw-bold ${discountType === "€" ? "text-white" : "bg-light text-secondary border"}`} 
                    style={discountType === "€" ? { backgroundColor: "#f09436", borderRadius: 0 } : { borderRadius: 0 }}
                    onClick={() => setDiscountType("€")}
                  >
                    €
                  </button>
                  <button 
                    className={`btn fw-bold ${discountType === "%" ? "text-white" : "bg-light text-secondary border"}`} 
                    style={discountType === "%" ? { backgroundColor: "#f09436", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 } : { borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                    onClick={() => setDiscountType("%")}
                  >
                    %
                  </button>
                </div>
              </div>
              <button 
                className="btn w-100 text-white fw-bold py-2" 
                style={{ backgroundColor: "#85d6ed", borderRadius: "4px" }}
                onClick={handleValidate}
              >
                APPLIQUER LA REMISE
              </button>
            </div>

            {/* NOTE */}
            <div className="mb-2">
              <div className="text-uppercase text-secondary mb-2" style={{ letterSpacing: "1px", fontSize: "0.9rem" }}>NOTE</div>
              <textarea 
                className="form-control mb-2" 
                rows="3"
                value={note}
                onChange={(e) => setNote(e.target.value)}
                style={{ resize: "none" }}
              ></textarea>
              <div className="d-flex gap-2">
                <button 
                  className="btn text-white fw-bold py-2 flex-grow-1" 
                  style={{ backgroundColor: "#85d6ed", borderRadius: "4px" }}
                  onClick={handleValidate}
                >
                  ENREGISTRER
                </button>
                <button 
                  className="btn text-white fw-bold py-2" 
                  style={{ backgroundColor: "#85d6ed", borderRadius: "4px", width: "45px" }}
                  onClick={onClose}
                >
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>
            </div>
          </div>

          <div className="border-top text-center bg-white" style={{ borderBottomLeftRadius: "12px", borderBottomRightRadius: "12px" }}>
            <button 
              className="btn btn-link w-100 py-3 text-info fw-bold text-decoration-none" 
              onClick={onClose}
            >
              FERMER
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartItemEditModal;
